import Shuffle from 'shufflejs';
const handleShuffle = () => {
  const elem = document.querySelector('.shuffle-container');
  const sizer = document.querySelector('.shuffle-sizer');

  if (elem && sizer) {
    var shuffleInstance = new Shuffle(elem, {
      itemSelector: '.shuffle-item',
      sizer: sizer,
    });
    Shuffle.options = {
      gutterWidth: 20,
    };

    const btns = [...document.querySelectorAll('[data-group]')];

    const removeActiveBtns = () => {
      btns.forEach((btn) => {
        btn.classList.remove('btn__active');
      });
    };

    btns.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        removeActiveBtns();
        e.target.classList.add('btn__active');
        const group = e.target.dataset.group;
        if (group === 'all') {
          shuffleInstance.filter();
        } else {
          shuffleInstance.filter(group);
        }
      });
    });
  }
};

export default handleShuffle;
